/* eslint-disable no-document-queryselector */
const FAQ_DOM_NODE_SELECTOR = "#faq";

export const querySelector = (selector: string) =>
  document.querySelector(`${FAQ_DOM_NODE_SELECTOR} ${selector}`);

export const querySelectorAll = (selector: string) =>
  document.querySelectorAll(`${FAQ_DOM_NODE_SELECTOR} ${selector}`);
